import { render, staticRenderFns } from "./Editorial.vue?vue&type=template&id=ee7dae42&scoped=true"
import script from "./Editorial.vue?vue&type=script&lang=js"
export * from "./Editorial.vue?vue&type=script&lang=js"
import style0 from "./Editorial.vue?vue&type=style&index=0&id=ee7dae42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7dae42",
  null
  
)

export default component.exports